import { Modal } from "react-bootstrap";
import {TruckInfo} from "./NewEditTruckModal";
import {businessYearService} from "../../services/businessYearService";
import {customerService} from "../../services/customerService";

interface NewEditTruckModalProps {
    show: boolean;
    toggle: () => void;
    refreshData: () => void;
    customerId: number;
    businessYear: number;
}

const NewJobModal: React.FC<NewEditTruckModalProps> = ({ show, toggle, refreshData, customerId, businessYear}) => {
    return (
        <Modal show={show} onHide={toggle} className="fade forRealModal" id="newJobModal" data-bs-backdrop="static" data-bs-keyboard="false"
             tabIndex={-1} aria-labelledby="newJobModal" aria-hidden="true">
            <Modal.Dialog className="">
                <div className="modal-content">
                    <div className="modal-body text-center">
				<span className="text-light icon mb-3">
                    <i className="fa-solid fa-square-question"></i>
                </span>
                        <p className="mb-4">
                            Are you sure you want to create a new job record?
                        </p>
                        <div className="mb-2">
                            <button onClick={async () => {
                                await customerService.createNewJob(customerId, businessYear);
                                refreshData();
                                toggle();
                            }} type="button" className="btn btn-primary text-strong text-uppercase m-100">Yes,
                                create new job
                            </button>
                        </div>
                        <div className="pb-2">
                            <a role="button" onClick={toggle} className="m-100 text-muted" data-bs-dismiss="modal">Nevermind</a>
                        </div>
                    </div>
                </div>
            </Modal.Dialog>
        </Modal>
    );
}
export default NewJobModal;